import * as Yup from "yup";

export const projectsValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  banner: Yup.string().required("Banner is required"),
  description: Yup.string().required("Description is required"),
});
